import {Injectable} from '@angular/core';

export class StringTransformer {

  word: string;

  constructor(word: string) {
    this.word = word;
  }

  cleanAccents(): StringTransformer {
    if (this.word !== null && this.word !== undefined) {
      this.word = this.word.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return this;
  }

  capitalizeFirstLetters(): StringTransformer {
    if (this.word !== null && this.word !== undefined) {
      this.word = this.word.split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .reduce((a, b) => a === null ? b : a + ' ' + b, null);
    }
    return this;
  }

  toUpperCase(): StringTransformer {
    if (this.word !== null && this.word !== undefined) {
      this.word = this.word.toUpperCase();
    }
    return this;
  }

  toSnakeCase(): StringTransformer {
    if (this.word !== null && this.word !== undefined) {
      this.word = this.word.replace(' ', '_').replace(' ', '_').replace(' ', '_');
    }
    return this;
  }

  build(): string {
    return this.word;
  }
}

@Injectable({
  providedIn: 'root'
})
export class StringUtils {

  static getStringTransformer(word: string): StringTransformer {
    return new StringTransformer(word);
  }

}

